import React from 'react'
import { connect } from 'react-redux'
import allRoles from '../../roles/roles'
import {
	addListItem, changeListItem, deleteListItem, getListFromValues,
	hasChangedValues, getFormValue, changeItemsValue, nullDate
} from '../../public/utility'
import { doGetExternalExperience, doSaveExternalExperience, doDeleteExternalExperience } from '../../reducers/actions'

class ExternalExperienceDiv extends React.Component {
	state = {
	}

	componentDidMount = () => {
		this.doGetExternalExperience()
	}

	doGetExternalExperience = () => {
		const { dispatch, id, personID } = this.props

		dispatch(doGetExternalExperience({
			id: id || 0,
			personID: personID || 0,
			onEnd: ({ errorMessage, initValues基本信息 }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					this.setState({ id, personID, initValues基本信息, changedValues基本信息: {} })
				}
			}
		}))
	}

	handlerSave = () => {
		const { dispatch, onClose, onRefresh } = this.props
		const { id, personID, initValues基本信息, changedValues基本信息, } = this.state
		const values = { ...initValues基本信息, ...changedValues基本信息 }

		dispatch(doSaveExternalExperience({
			id: id || 0,
			personID: personID || 0,
			changedValues基本信息,
			onEnd: ({ errorMessage }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					Ext.toast('保存成功')
					onRefresh && onRefresh()
					onClose && onClose()
				}
			}
		}))
	}

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}


	canSave = () => {
		return this.bChanged()
	}

	handleChange = v => {
		const { initValues基本信息, changedValues基本信息 } = this.state
		const values = { ...initValues基本信息, ...changedValues基本信息 }
		const startDate = values.入职日期
		const endDate = values.离职日期
		var dYear = 0
		var dMonth = 0
		if (startDate !== nullDate && endDate !== nullDate && startDate <= endDate) {
			var day = parseInt((endDate - startDate) / 1000 / 3600 / 24) + 1
			if (Math.floor(day / 365) > 0) {
				dYear = parseInt(Math.floor(day / 365));
			}
			if (Math.floor(day % 365 / 30) > 0) {
				dMonth = parseInt(Math.floor(day % 365 / 30));
			}
		}
		Tyan.utility.changeItemsValue(this, '基本信息', '在职年资资年', dYear || '')
		Tyan.utility.changeItemsValue(this, '基本信息', '在职年资资月', dMonth || '')
	}

	bChanged = () => {
		const { initValues基本信息, changedValues基本信息 } = this.state
		const values = { ...initValues基本信息, ...changedValues基本信息 }
		return hasChangedValues(this) && values.公司名称 && (values.承认年资年 || values.承认年资月)
	}

	fieldset基本信息 = () => {
		return [
			{ _text: '公司名称', minWidth: '50%', required: true, },
			{ _text: '部门名称', minWidth: '50%' },
			{ _text: '职务名称', minWidth: '50%', },
			{ _text: '职务内容', minWidth: '50%' },
			{ _text: '月薪', minWidth: '50%' },
			{ _text: '主管姓名', minWidth: '50%', },
			{ _date: '入职日期', minWidth: '50%', onChange: this.handleChange },
			{ _date: '离职日期', minWidth: '50%', onChange: this.handleChange },
			{
				_group: '', margin: 0, minWidth: '50%', items: [
					{ _label: '在职年资', minWidth: '100px', margin: '5 0 5 20', },
					{ _number: '', name: '在职年资资年', minWidth: '40px', _full: true, disabled: true, },
					{ _label: '年', maxWidth: '10px', margin: '5 0' },
					{ _number: '', name: '在职年资资月', minWidth: '40px', _full: true, disabled: true, },
					{ _label: '月', maxWidth: '10px', margin: '5 0' },
					{ _label: '', minWidth: '5px', flex: 2, margin: '5 0' },
				]
			},
			{
				_group: '', margin: 0, minWidth: '50%', items: [
					{ _label: '承认年资<font style=\'color:red\'>*</font>', minWidth: '100px', margin: '5 0 5 20', },
					{ _number: '', name: '承认年资年', minWidth: '40px', _full: true },
					{ _label: '年', maxWidth: '10px', margin: '5 0' },
					{ _number: '', name: '承认年资月', minWidth: '40px', _full: true, maxValue: 12, minValue: 0 },
					{ _label: '月', maxWidth: '10px', margin: '5 0' },
					{ _label: '', minWidth: '5px', flex: 2, margin: '5 0' },
				]
			},
			{ _text: '离职原因', minWidth: '95%', maxRows: 3 },
			{ _files: '附件', minWidth: '95%', },
			{ _text: '备注', minWidth: '95%', maxRows: 3 }
		]
	}

	render() {
		const { showMessage: Message, showBody: Body, bDelete, bReadOnly } = this.props
		const { errorMessage, id, initValues基本信息, changedValues基本信息 } = this.state

		if (errorMessage) return Tyan.pubForm.showError(errorMessage)
		if (!initValues基本信息) return <Message text={'请稍等 ...'} />
		return <Body data={this} maxWidth="1000"
			controls={
				!bDelete || bReadOnly ? [{ _button: '关闭', icon: 'close', handler: this.handlerClose }] :
					[
						{ _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.canSave() },
						{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
					]
			}
			fieldsets={
				[
					{ title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: !bDelete || bReadOnly },
				]}
		/>
	}
}

export default connect()(ExternalExperienceDiv)